import React, { Component } from "react";
import { ImageBackground, Text, View, StyleSheet, Button, Picker, ScrollView, Image,TouchableOpacity, Dimensions } from "react-native";
import ReactContactForm from 'react-mail-form'
import { Document, Page } from 'react-pdf'
import Pdf from 'react-pdf-js'
import myPDF from './NetReport1.pdf'
//import { styles } from "../utils/styles";
//import SomeCustomComponent from "./SomeCustomComponent";

// see https://github.com/necolas/react-native-web

class App extends Component {
  pagesCount = 0
  constructor(props){
    super(props)
    this.state={
      infoHeight: -window.innerWidth+1800,
      pageNumber: 1,
      pdf: 0
    }
  }
  componentDidMount() {
    window.addEventListener("resize", () => { this.setState({infoHeight: -window.innerWidth+1800})});

  }
  onDocumentComplete = (pages) => {
    this.pagesCount = pages
  }

  render() {
    return (
      <View>
      <ScrollView style ={{backgroundColor: 'black'}}>
      <View style={styles.back}>
          {/* <Text style={styles.headerTitle}>cool</Text> */}
          <ImageBackground style={styles.headerImage} source={require('./drone.JPG')}>
            <View style = {styles.blackTint}>
              <Text style={styles.headerTitle}>GRAVITY AI</Text>
              <Text style={styles.headerKite}>BLACK KITE 
                <Text style={styles.kiteAITitle}>  DRONE INTELLIGENCE</Text>
              </Text>
            </View>
          </ImageBackground>
          {/* <View style={[styles.infoBack, {height: this.state.infoHeight}]}> */}
          <ImageBackground style={[styles.infoBack, {height: this.state.infoHeight}]} source={require('./drone2.JPG')}>
            <View style = {[styles.blackTint, {backgroundColor: 'rgba(0, 0, 0, 0.9)', height: this.state.infoHeight, minHeight: 600}]}>
              <Text style={styles.infoTitle}>BLACK KITE</Text>
              <Text style={styles.aboutKite}>Black Kite is a research project with the goal of using AI and Machine Learning inside drones to better asses situations, identify targets and identify civilians to create a more capable, effective, safer, and intelligent drone.</Text>
              <Text style={styles.versionTitle}>VERSION 1</Text>
              <Text style={[styles.aboutKite, {top: '45%'}]}>Version 1(V1) is focusing on decreasing civilian casualties by making a Drone Intelligence that values human life. Using deep learning,  V1 is able determine the best possible moment to take out a target that will at the same time do the least possible destruction to any civilians that happen to be in the area.  The AI considers any civilians in the area and will maximize its chances of avoiding them while at the same time taking out the appropriate target.</Text>
              <View style={[styles.infoBack, {minHeight: 150, height: 150, backgroundColor: 'transparent', alignItems: 'center', top: '75%'}]} source={require('./drone2.JPG')}>
                <Text style={[styles.infoTitle, {color: 'white', fontSize: 18, top: 20, width: '100%', textAlign: 'center', left: 0}]}>VERSION 1 RESEARCH PAPER</Text>
                <TouchableOpacity onPress={() => { this.setState({pdf: 1})}}>
                  <View style={styles.button}>
                    <Text style={styles.open}>VIEW</Text>
                  </View>
                </TouchableOpacity>
              </View>
            </View>
         
          </ImageBackground>
           {/* </View> */}
           {/* <View style={[styles.infoBack, {minHeight: 150, height: 150, backgroundColor: 'rgba(10, 10, 10, 1)', alignItems: 'center'}]} source={require('./drone2.JPG')}>
            <Text style={[styles.infoTitle, {color: 'white', fontSize: 18, top: 20, width: '100%', textAlign: 'center', left: 0}]}>VERSION 1 RESEARCH PAPER</Text>
            <TouchableOpacity onPress={() => { this.setState({pdf: 1})}}>
              <View style={styles.button}>
                <Text style={styles.open}>VIEW</Text>
              </View>
            </TouchableOpacity>
           </View> */}
           <View style={[styles.infoBack, {marginTop: 50, minHeight: 100, height: 100, backgroundColor: 'transparent'}]} source={require('./drone2.JPG')}>
            <Text style={[styles.infoTitle, {color: 'white'}]}>CONTACT</Text>
            <Text style={[styles.infoTitle, {top: '50%'}]}>gravityaiinfo@gmail.com</Text>
           </View>
           
          {/* <View stlye={[styles.infoBack, {backgroundColor: 'blue'}]}>
            <Text>gravityaiinfo@gmail.com</Text>
          </View> */}
          {this.pdfView(this.state.pdf, this.state.pageNumber)}
        
  
      </View>

     </ScrollView>
     </View>
   
    );
  }

  pdfView = (statePdf, page) => {
    if (statePdf == 0) {
      return null
    }else {
      return (
        <View style = {styles.pdf}>
          <View style = {styles.pdfView}>
              <TouchableOpacity onPress={() => { this.setState({pdf: 0})}}>
                <View style={styles.exit}>
                  <Text style={[styles.open, {fontSize: 30}]}>X</Text>
                </View>
              </TouchableOpacity>
              <Pdf file={myPDF} page={page} onDocumentComplete={(pages) => { this.onDocumentComplete(pages) }}/>
              <View style={styles.buttonHolder}>
                <TouchableOpacity onPress={() => { this.pageDown() }}>
                  <View style = {styles.next}>
                    <Text style={[styles.open]}>BACK</Text>
                  </View>
                </TouchableOpacity>
                <TouchableOpacity onPress={() => { this.pageUp() }}>
                  <View style = {styles.next}>
                    <Text style={[styles.open]}>NEXT</Text>
                  </View>
                </TouchableOpacity>
              </View>
              <View/>
          </View>
        </View>
      )
    }
  }

  pageUp = () => {
    if (this.state.pageNumber !== this.pagesCount) {
      this.setState({pageNumber: this.state.pageNumber + 1})
    }
  }
  pageDown = (page) => {
    this.docEnd = false
    if (this.state.pageNumber !== 1) {
      this.setState({pageNumber: this.state.pageNumber - 1})
    }
  }
}

const styles = StyleSheet.create({
  back: {
    // flex: 1,
    //sposition:'fixed',
    // width: '100',
    backgroundColor: 'black',
    height: 1800,
    // margin: 0,
    // padding: 0,
    // justifyContent: 'center',
    // alignItems: 'center'
  },
  headerTitle: {
    marginTop: 20,
    marginLeft: 10,
    color: 'white',
    fontSize: 20,
    fontFamily: "Verdana",
    fontWeight: '200'
    
  },
  headerImage: {
    position:'fixed',
    width: '100%',
    height: '40%',
    tintColor: 'rgba(255, 255, 255, 0.5)'
  },
  blackTint: {
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)'
  },

  headerKite: {
    position: 'absolute',
    left: '10%',
    top: '75%',
    color: 'rgba(45, 45, 45, 1.0)',
    fontSize: 65,
    fontFamily: "Verdana",
    fontWeight: '200'
    
  },
  kiteAITitle: {
    position: 'absolute',
    left: '-2%',
    top: '100%',
    width: 250,
    color: 'white',
    fontSize: 20,
    fontFamily: "Verdana",
    fontWeight: '200'
    
  },
  infoBack: {
    top: "40%",
    width: '100%',
    height: 600,
    minHeight: 600,
    backgroundColor: 'rgba(35, 35, 35, 1.0)',

    // flex: 1,
    // backgroundColor: 'blue'
  },
  infoTitle: {
    position: 'absolute',
    left: '11%',
    top: '10%',
    color: 'rgba(160, 160, 160, 1.0)',
    fontSize: 25,
    fontFamily: "Verdana",
    fontWeight: '200'
  },
  aboutKite: {
    position: 'absolute',
    left: '11%',
    top: '20%',
    color: 'white', //'rgba(225, 225, 225, 1.0)',
    fontSize: 15,
    fontFamily: "Verdana",
    fontWeight: '100',
    marginRight: '10%',
    lineHeight: 30
  },
  versionTitle: {
    position: 'absolute',
   // textAlign: 'center',
    left: '11%',
    width: '90%',
    top: '40%',
    color: 'rgba(160, 160, 160, 1.0)',
    fontSize: 18,
    fontFamily: "Verdana",
    fontWeight: '200',
  },
  contact: {
    position:'fixed',
    width: '100%',
    height: '40%',
    top: '100%',
    backgroundColor: 'blue'
    //backgroundColor: 'rgba(35, 35, 35, 1.0)',

    //flex: 1,
    // backgroundColor: 'blue'
  },

  button: {
    top: 70,
    width: 150,
    height: 50,
    backgroundColor: 'white', //'rgba(35, 35, 35, 1.0)',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 35

    // flex: 1,
    // backgroundColor: 'blue'
  },
  open: {
    position: 'absolute',
    fontSize: 17,
    fontFamily: "Verdana",
    fontWeight: '200',
    color: 'rgba(20, 20, 20, 1)'
    
  },
  pdfView: {
    marginTop: 300,
    top: '0%',
    // transform: [{scaleX: 0.75}, {scaleY:0.9}],
     //'rgba(35, 35, 35, 1.0)',

    // flex: 1,
    // backgroundColor: 'blue'
  },
  pdf: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: 2000,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(35, 35, 35, 0.5)',

    
  },
  buttonHolder: {
    width: '100%',
    height: 150,
    flexDirection: 'row',
    justifyContent: 'center',
  },
  next: {
    top: 10,
    //left: '30%',
    width: 150,
    height: 50,
    backgroundColor: 'white', //'rgba(35, 35, 35, 1.0)',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 35,
    margin: 20

    
  },
  exit: {
    top: 0,
    left: '90%',
    width: 75,
    height: 75,
    backgroundColor: 'white', //'rgba(35, 35, 35, 1.0)',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 37.5,
    margin: 20
  }


})

export default App;